import { h, Component } from 'preact';
import GalleriesComponent from '../components/galleries.component';
import PhotoViewerComponent from '../components/photoviewer.component';

export default class GalleryView extends Component {
    render() {
        return (
            <main class="main-ocm" role="main" id="main">
                <PhotoViewerComponent />
                <GalleriesComponent />
            </main>
        );
    }
}
